<div class="title">
  <div class="flex items-center justify-between gap-3 py-3">
<h1 class="text-xl sm:text-xl font-bold text-[#151D48] truncate">
  {{ 'TERM_SHEET.TITLE' | translate }}
</h1><app-back-button></app-back-button>
 
  </div>
</div>
<div class="flex items-center justify-between mb-6">
  <button (click)="downloadTerms()" class="px-6 py-2 rounded-lg bg-green-700 text-white">
    {{ 'TERM_SHEET.DOWNLOAD_TERMS' | translate }}
  </button>

 <button
  *ngIf="!isViewMode"
  (click)="addSection()"
  class="px-4 py-2 rounded-lg bg-secondary text-white text-sm">
  {{ 'TERM_SHEET.ADD_NEW_SECTION' | translate }}
</button>
</div>
<section class="bg-white rounded-2xl border p-4">
  <!-- HEADER -->

  <!-- LOADER -->
  <div *ngIf="isLoading" class="text-center text-gray-400 mb-4">{{ 'TERM_SHEET.LOADING' | translate }}</div>

  <!-- EMPTY -->
  <div *ngIf="!isLoading && sections.length === 0" class="text-gray-400 text-center mb-4">
    {{ 'TERM_SHEET.NO_SECTIONS' | translate }}
  </div>

  <!-- SECTIONS -->
  <div *ngFor="let section of sections; let i = index" class="mb-6 border-b pb-4">
    <!-- HEADER -->
    <div class="flex justify-between items-center mb-2">
      <span class="text-sm font-semibold text-[#151D48]"> </span>

<button
  *ngIf="!isViewMode"
  class="text-red-500 text-sm"
  (click)="deleteSection(i)">
  {{ 'TERM_SHEET.DELETE' | translate }}
</button>    </div>

 <!-- DROPDOWN -->
<div class="mb-3">
  <label class="text-sm font-medium">
    {{ 'TERM_SHEET.SECTION_CODE' | translate }}
  </label>

  <select
    class="w-full h-11 rounded-xl border px-3
           disabled:bg-gray-100 disabled:text-gray-500
           disabled:cursor-not-allowed"
    [(ngModel)]="section.code"
    [disabled]="isViewMode"
  >
    <option [ngValue]="null">
      {{ 'TERM_SHEET.SELECT_SECTION' | translate }}
    </option>

    <option
      *ngFor="let opt of sectionOptions"
      [ngValue]="opt.value"
    >
      {{ opt.label | translate }}
    </option>
  </select>
</div>

<!-- DESCRIPTION -->
<div>
  <label class="text-sm font-medium">
    {{ 'TERM_SHEET.DESCRIPTION' | translate }} <span class="text-red-500">*</span>
  </label>

  <div
    class="rounded-xl"
    [class.ring-1]="descriptionChecked && isDescriptionMissing(section)"
    [class.ring-red-500]="descriptionChecked && isDescriptionMissing(section)"
  >
    <app-rich-text-editor
      [(ngModel)]="section.description"
      [editable]="!isViewMode"
      minHeight="120px"
      [placeholder]="'TERM_SHEET.DESCRIPTION_PLACEHOLDER' | translate"
    ></app-rich-text-editor>
  </div>
  <div *ngIf="descriptionChecked && isDescriptionMissing(section)" class="text-red-500 text-xs mt-1">
    {{ 'TERM_SHEET.DESCRIPTION_REQUIRED' | translate }}
  </div>
</div>
  </div>
</section>
<!-- ACTIONS -->
<div class="flex gap-4 mt-6">
 <button
  *ngIf="!isViewMode"
  (click)="saveTerms()"
  class="px-6 py-2 rounded-lg bg-secondary text-white"
  [disabled]="isLoading">
  {{ 'TERM_SHEET.SAVE' | translate }}
</button>

  <button
  *ngIf="!isViewMode && hasValidSections()"
  (click)="submitLead()"
  class="px-6 py-2 rounded-lg bg-red-900 text-white"
  [disabled]="isLoading">
  {{ 'TERM_SHEET.SUBMIT' | translate }}
</button>
</div>
